import { render, staticRenderFns } from "./AdminActionLogs.vue?vue&type=template&id=6198bc35"
import script from "./AdminActionLogs.vue?vue&type=script&lang=js"
export * from "./AdminActionLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports